import { render, staticRenderFns } from "./SizeList.vue?vue&type=template&id=86101418&scoped=true&"
import script from "./SizeList.vue?vue&type=script&lang=js&"
export * from "./SizeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86101418",
  null
  
)

export default component.exports